import React, { useMemo } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import CssBaseline from "@material-ui/core/CssBaseline";
import List from "@material-ui/core/List";
import Divider from "@material-ui/core/Divider";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import SearchIcon from "@material-ui/icons/Search";
import PersonIcon from "@material-ui/icons/Person";
import ListItemText from "@material-ui/core/ListItemText";
import BusinessCenterIcon from "@material-ui/icons/BusinessCenter";
import AddIcon from "@material-ui/icons/Add";
import ClientsPage from "./ClientsPage";
import DataPage from "./DataPage";
import { Route, Switch, useRouteMatch } from "react-router";
import { LinkStyled, StyledListItem } from "../styles/genericStyles";
import AttachMoneyIcon from "@material-ui/icons/AttachMoney";
import AccountTreeIcon from "@material-ui/icons/AccountTree";
import SuppliersPage from "./SuppliersPage";
import NewCasePage from "./NewCasePage";
import SearchPage from "./SearchPage";
import ProfilePage from "./ProfilePage";
import ResultsPage from "./ResultsPage";
import useUserName from "../hooks/useUserName";
import useFetch from "../hooks/useFetch";
import PdfModal from "../components/generic/PdfModal";

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  appBar: {
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: drawerWidth,
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
  },
  drawerPaper: {
    width: drawerWidth,
  },
  // necessary for content to be below app bar
  toolbar: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.default,
    padding: theme.spacing(3),
  },
}));

const Items = [
  {
    name: "New Case",
    icon: <AddIcon />,
    path: "/new-case",
    component: <NewCasePage />,
  },
  {
    name: "Search",
    icon: <SearchIcon />,
    path: "/search",
    component: <SearchPage />,
  },
  {
    name: "Data",
    icon: <AccountTreeIcon />,
    path: "/data",
    component: <DataPage />,
  },
  {
    name: "Clients",
    icon: <AttachMoneyIcon />,
    path: "/clients",
    component: <ClientsPage />,
  },
  {
    name: "Suppliers",
    icon: <BusinessCenterIcon />,
    path: "/suppliers",
    component: <SuppliersPage />,
  },
  {
    name: "Profile",
    icon: <PersonIcon />,
    path: "/profile",
    component: <ProfilePage />,
  },
];

const AdminPage = () => {
  useFetch({ path: "employee", resourceName: "employees" });

  const classes = useStyles();
  const userName = useUserName();
  const { path, url } = useRouteMatch();

  const subPath = window.location.pathname.replace(url, "");

  return (
    <div className={classes.root}>
      <CssBaseline />
      <Drawer
        className={classes.drawer}
        variant="permanent"
        classes={{
          paper: classes.drawerPaper,
        }}
        anchor="left"
      >
        <Divider />
        <List
          style={{ display: "flex", flexDirection: "column", height: "100%" }}
        >
          {Items.map((item, index) => {
            const lastChild = index === Items.length - 1;
            const selected = subPath === item.path;

            return (
              <React.Fragment key={index}>
                <StyledListItem
                  lastchild={+lastChild}
                  selected={selected}
                  button
                  component={LinkStyled}
                  to={`${url}${item.path}`}
                  key={item.name}
                >
                  <ListItemIcon>{item.icon}</ListItemIcon>
                  <ListItemText
                    primary={
                      item.name === "Profile" && userName ? userName : item.name
                    }
                  />
                </StyledListItem>
                {!lastChild && <Divider />}
              </React.Fragment>
            );
          })}
        </List>
      </Drawer>
      <main className={classes.content}>
        <PdfModal />
        <div className={classes.toolbar}>
          <Switch>
            {Items.map((item, index) => (
              <Route key={index} path={`${path}${item.path}`}>
                {item.component}
              </Route>
            ))}
            <Route path={`${path}/results/:tabName`}>
              <ResultsPage />
            </Route>
          </Switch>
        </div>
      </main>
    </div>
  );
};

export default AdminPage;
